import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4 py-10 text-center text-teal-700 dark:text-gray-200" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-4xl" }, " 404 Page Not Found ")
], -1)

import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_view),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "btn m-3 text-sm mt-8",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, " Back ")
    ])
  ]))
}
}

})